import Joi from "joi";
import { findDuplicateIndices } from "./utils";

const groupsSchema = Joi.object({ franchiseName: Joi.string().required() });

const areaSchema = Joi.object({
	areaLabel: Joi.string().required(),
	areaValue: Joi.string().required(),
	version: Joi.string().required(),
	area: Joi.link("#areaSchema").allow(null),
}).id("areaSchema");

const franchisesSchema = Joi.object({
	dealerCode: Joi.string().alphanum().max(8).required(),
	franchise: Joi.string().required(),
	groups: Joi.array().items(groupsSchema),
	area: areaSchema,
});

const locationDealerCodesSchema = Joi.object({
	oemReference: Joi.string().required(),
	dealerCodeFS: Joi.string().alphanum().max(8).required(),
	legalName: Joi.string().required(),
	dba: Joi.string().required(),
	franchises: Joi.when("oemReference", {
		is: Joi.string().not("N/A"),
		then: Joi.array().items(franchisesSchema).required(),
	}),
	financialStatementVersion: Joi.when("oemReference", {
		is: Joi.string().not("N/A"),
		then: Joi.string().required(),
	}),
	version: Joi.when("oemReference", {
		is: Joi.string().not("N/A"),
		then: Joi.string().required(),
	}),
});

export const arrayOfDealerCodesSchema = Joi.array()
	.items(locationDealerCodesSchema)
	.custom((value, helpers) => {
		const dealerCodesFs = value.map((item: { dealerCodeFS: string }) => item.dealerCodeFS);
		const uniqueDealerCodesFs = new Set(dealerCodesFs);
		if (uniqueDealerCodesFs.size !== dealerCodesFs.length) {
			const errorDetails = findDuplicateIndices(dealerCodesFs);
			return helpers.error("unique.DealerCodeFS", { details: errorDetails });
		}
		return value;
	}, "unique.DealerCodeFS");
